import { Col, Row } from "reactstrap";
import moment from "moment";
import "./InvoiceDetailsComp.css";
import { formatCurrency } from "../../../../utils/formatCurrency";
import InvoiceFooter from "./InvoiceFooter";
import InvoiceHeader from "./InvoiceHeader";

export default function InvoiceDetailsComp({ invoice }) {
  return (
    <div className="">
      <InvoiceHeader
        invoice={invoice}
        type="invoice-details"
        total={invoice?.total_price}
      />

      <div className="separator mb-4 mt-1"></div>

      {invoice.invoiceablesDays.filter(
        (inv) => inv.collection_id && inv.totalHours > 0
      ).length > 0 && (
        <Row className="g-3">
          <Col md={12}>
            <div className="invoiceable head fs-13-print">
              <span className="name">Shift Name</span>
              <span className="name">Hour Collection</span>
              <span className="date">Date</span>
              <span className="hours">Total Hours</span>
              <span className="hours text-nowrap">Total Hour Price</span>
              <span className="price">Price</span>
            </div>

            {invoice.invoiceablesDays
              .filter((inv) => inv.collection_id && inv.totalHours > 0)
              .map((inv, idx) => {
                return (
                  <div className="invoiceable fs-13-print" key={"inv1" + idx}>
                    <span className="name">{inv.shiftName}</span>
                    <span className="name">{inv.name}</span>
                    <span className="date">
                      {inv.from
                        ? moment.utc(inv.from).format("DD MMM YYYY")
                        : "-"}
                    </span>
                    <span className="hours">
                      {inv.totalHours ? inv.totalHours.toFixed(2) : "-"}
                    </span>
                    <span className="hours">
                      {inv.totalHourPrice
                        ? formatCurrency(inv.totalHourPrice)
                        : "-"}
                    </span>
                    <span className="price">
                      {inv.price ? formatCurrency(inv.price) : "-"}
                    </span>
                  </div>
                );
              })}

            <div className="invoiceable head fs-14-print">
              <span>Total</span>
              <span>
                {formatCurrency(
                  invoice.invoiceablesDays
                    .filter((inv) => inv.collection_id)
                    .filter((inv) => inv.totalHours > 0)
                    .reduce((acc, inv) => acc + inv.price, 0)
                )}
              </span>
            </div>
          </Col>
        </Row>
      )}

      <div className="separator mb-4 mt-4"></div>

      {invoice.invoiceablesDays
        .filter((inv) => !inv.collection_id)
        .filter((inv) => inv.totalHours > 0).length > 0 && (
        <Row className="g-3">
          <Col md={12}>
            <div className="invoiceable head fs-14-print">
              <span className="name">Name</span>
              <span className="price">Price</span>
            </div>

            {invoice.invoiceablesDays
              .filter((inv) => !inv.collection_id)
              .filter((inv) => inv.totalHours > 0)
              .map((inv, idx) => (
                <div className="invoiceable fs-14-print" key={"inv2" + idx}>
                  <span className="name">{inv.name}</span>
                  <span className="price">{formatCurrency(inv.price)}</span>
                </div>
              ))}

            <div className="invoiceable head fs-15-print">
              <span>Total</span>
              <span>
                {formatCurrency(
                  invoice.invoiceablesDays
                    .filter((inv) => !inv.collection_id)
                    .filter((inv) => inv.totalHours > 0)
                    .reduce((acc, inv) => acc + inv.price, 0)
                )}
              </span>
            </div>
          </Col>
          <div className="separator mb-4 mt-4"></div>
        </Row>
      )}

      {invoice.priceComponents?.filter(
        (com) => com.priceComponent.isFinanceFees == true
      ).length > 0 && (
        <Row className="g-3">
          {invoice.priceComponents
            .filter((com) => com.priceComponent.isFinanceFees == true)
            .map((item) => (
              <Col md={12}>
                <div className="invoiceable fs-14-print" key={item.id}>
                  <span className="name">{item.priceComponent.name}</span>
                  <span className="price">{formatCurrency(item.value)}</span>
                </div>
              </Col>
            ))}
          <div className="separator mb-4 mt-4"></div>
        </Row>
      )}

      {invoice.priceComponents?.filter(
        (com) => com.priceComponent.isVat == true
      ).length > 0 && (
        <Row className="g-3">
          {invoice.priceComponents
            .filter((com) => com.priceComponent.isVat == true)
            .map((item) => (
              <Col md={12}>
                <div className="invoiceable fs-14-print" key={item.id}>
                  <span className="name">{item.priceComponent.name}</span>
                  <span className="price">{formatCurrency(item.value)}</span>
                </div>
              </Col>
            ))}
          <div className="separator mb-4 mt-4"></div>
        </Row>
      )}

      {invoice.fines.length > 0 && (
        <div
          className="fs-14-print"
          style={{ textAlign: "right", fontSize: "19px", fontWeight: "bold" }}
        >
          <span>Fines: </span>
          <span>
            {formatCurrency(
              invoice.fines.reduce(
                (acc, c) => acc + c.administration_cost + c.cost,
                0
              )
            )}
          </span>
          <div className="separator mb-4 mt-4"></div>
        </div>
      )}

      {invoice.privateUses.length > 0 && (
        <div
          className="fs-14-print"
          style={{ textAlign: "right", fontSize: "19px", fontWeight: "bold" }}
        >
          <span>Private Use: </span>
          <span>
            {formatCurrency(
              invoice.privateUses.reduce((acc, c) => acc + c.cost, 0)
            )}
          </span>
          <div className="separator mb-4 mt-4"></div>
        </div>
      )}

      <div
        className="mb-4 mt-1 text-end fs-16-print"
        style={{ fontSize: "21px", fontWeight: "bold" }}
      >
        <span>Total: </span>
        <span>{formatCurrency(invoice?.total_price)}</span>
      </div>

      <InvoiceFooter invoice={invoice} />
    </div>
  );
}
